// * GET =====================================
export const ALERT_GET_LIST = `/utils_data_object/list_alerts`;

// * PATCH ===================================
export const ALERT_PATCH_TOGGLE_MODE = (alertId: string) =>
  `/alert/${alertId}/toggle_mode`;

// * POST ====================================
export const ALERT_POST = (alertId: string) => `/alert/${alertId}`;
export const ALERT_POST_CREATE_FOR_FEED = (feedId: string) =>
  `/feed/${feedId}/alert`;

// * DELETE ==================================
export const ALERT_DELETE = (alertId: string) => `/alert/${alertId}`;

// * PUT =====================================
